import React, { useState, useEffect } from "react";
import { Body, Button, Header, Image, Logo, ClickLink, Input } from "../components";
import logo from "../cookin-lab1000.gif";

import { useForm } from "react-hook-form";
import { Container, Row, Col} from 'react-bootstrap';

import { getDefaultProvider, JsonRpcProvider, Web3Provider } from "@ethersproject/providers";
import useWeb3Modal from "../hooks/useWeb3Modal";
import Web3 from "web3";

const marginTop={"margin-top":"15px"};
function WalletButton({ provider, loadWeb3Modal, logoutOfWeb3Modal }) {
  return (
    <button
      type="button" class="nes-btn" style={marginTop}
      onClick={() => {
        if (!provider) {
          loadWeb3Modal();
        } else {
          logoutOfWeb3Modal();
        }
      }}
    >
      {!provider ? "Connect Wallet" : "Disconnect Wallet"}
    </button>
  );
}

async function getAddress() {
  const provider = new Web3Provider(window.ethereum);
  const signer = await provider.getSigner();
  const userAddress = await signer.getAddress();
  return userAddress;
}

//Functional Component
const OgWhitelist = () => {

  const [provider, loadWeb3Modal, logoutOfWeb3Modal] = useWeb3Modal();
  const {register, handleSubmit, errors} = useForm();
  const [address, setAddress] = useState("none");
  const [error, setError] = useState(null);
  const [status, setStatus] = useState("none")

  function Api(address, amount) {

    const url =  'https://meta-whitelist-api.herokuapp.com/whitelist/' + address + "/" + amount;
    setError(false);
    fetch(url)
        .then(res => res.text())
        .then(data => {
          setStatus(data);
          console.log(data);
        })
  }

  const onSubmit = (data) => {
    if (!provider) {
      setError("Please connect your wallet!")
    } else {
      getAddress().then(result => {
        setAddress(result);
        Api(result, data.amount)
      })
    }
  }

  function StatusComponent() {
    if (status == "none") {
      return(<div></div>)
    } else if (status == "false") {
      return(
        <span class="nes-text is-success">Semi-success! You don't qualify as OG but your address has been added to the public mint raffle.</span>
      )
    } else if (status == "true") {
      return(
        <span class="nes-text is-success">Success! Your address has been added to the OG whitelist.</span>
      )
    } else if (status == "expired") {
      return(
        <span class="nes-text is-error">Whitelisting has ended. Check our discord for more info.</span>
      )
    }
  }

  const styleMargin={"margin-bottom": "25px"};

  return (
    <div>
      <Header>
      </Header>
      <Body>
        <br/>
        <br/>
        <Logo src={logo} alt="ChemScripts-logo" />
        <br/>
        <h2>ChemScripts</h2>
        <br/>
        <span class="nes-text">OG whitelist</span>
        <span class="nes-text is-disabled">for the genesis mint</span>
        <Container>
        <br/>
        <Row>
          <Col>
            <div class="nes-container with-title is-rounded">

              <p/>
              <span class="nes-text">STEP 1: connect your wallet</span>
              <span class="nes-text is-error">{error}</span>
              <br/>
              <WalletButton provider={provider} loadWeb3Modal={loadWeb3Modal} logoutOfWeb3Modal={logoutOfWeb3Modal} />
              <p/>
              <p/>
              <span class="nes-text">STEP 2: How many molecules do you want to mint? (max. 10)*</span>
              <p/>
              <form onSubmit={handleSubmit(onSubmit)}>
              <input style={styleMargin} class="nes-input" id="molecule_field" type="number" placeholder="e.g. 3" required {...register("amount")}/>
              <button class={status == "none" && provider? "nes-btn is-primary" : "nes-btn is-disabled"} type="submit" value="Search">Apply for Whitelist</button>
              </form>
            </div>
            <StatusComponent/>
          </Col>
        </Row>
        <br/>
        <p/>
        <p/>
        <p/>
        <p/>
        <p/>
        <Row>
          <Col>
            <div class="nes-container is-rounded is-dark">
              <p>*Please only submit once, duplicates are removed. You are not guaranteed to get allocated the amount you wish to mint. OGs are holders of CryptoPunks, Meebits, ElementBlocks, and BeyondElements. Those are prioritized. If you hold none of these NFTs there is a public raffle in which a few whitelist spots are given away.</p>
            </div>
          </Col>
        </Row>

        </Container>
      </Body>
    </div>
  );
};

export default OgWhitelist;
